import { SearchPageFragment } from "@/__generated__/graphql";
import Error404 from "@/errorPages/Error404";
import Error500 from "@/errorPages/Error500";
import { getSearchPage } from "@api/graphql/queries";
import SearchPage from "@cmsPages/SearchPage";
import { initializeApollo } from "@lib/apolloClient";
import { getFrontendHostname, getTheme } from '@lib/config';
import type { GetServerSideProps, GetServerSidePropsContext, NextPage } from "next";


type SearchPageProps = {
  data: {
    search: SearchPageFragment
  };
  pageUrl: string;
  siteName: string;
  homepageUrl: string;
  errorCode?: number;
};

const SearchListingPage: NextPage<SearchPageProps> = (props: SearchPageProps) => {
  if (props.errorCode === 500) {
    return <Error500 />;
  }
  else if (props.errorCode) {
    return <Error404 />;
}
  return <SearchPage pageUrl={props.pageUrl} {...props.data.search} />;
};

export default SearchListingPage;

export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {
  const { res, req } = context;
  const theme = getTheme();
  const path = context.resolvedUrl;
  const hostname = getFrontendHostname();

  let pageUrl;
  if (req) {
    // Server side rendering
    pageUrl = 'https://' + hostname + req.url;
  } else {
    // Client side rendering
    pageUrl = window.location.href;
  }

  // Get current params for the query.
  const params = new URL(pageUrl).searchParams;
  // Keywords
  const keywords = params.get('keywords') ?? '';
  // Sort by
  const sortBy = params.get('sortBy') ?? null;
  // Page number
  const page = (Number.parseInt(params.get('page') || '0|') - 1) || 0;

  const apolloClient = initializeApollo();
  const result = await apolloClient.query({
    query: getSearchPage,
    variables: {
      keywords: keywords,
      sortBy: sortBy,
      page: Math.max(page, 0),
    }
  })
  .catch((e) => {
    console.error('[GraphQL] Search query failed:', e);
    res.statusCode = 500;
    return {
      data: {
        route:{}
      },
      errorCode: 500
    };
  });

  return {
    props: {
      theme: theme,
      pageUrl: pageUrl,
      hostname: hostname,
      ...result
    },
  };
};
